var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.circleStyle)},[(!_vm.$slots.icon)?_c('em',{class:_vm.iconClass,style:(_vm.iconStyle)}):_vm._e(),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }